import { render, staticRenderFns } from "./previewYGDLR.vue?vue&type=template&id=20f83b40&scoped=true&lang=html&"
import script from "./previewYGDLR.vue?vue&type=script&lang=js&"
export * from "./previewYGDLR.vue?vue&type=script&lang=js&"
import style0 from "./previewYGDLR.vue?vue&type=style&index=0&id=20f83b40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f83b40",
  null
  
)

export default component.exports